const baseUrl = process.env.REACT_APP_BASE_URL as string;

export const isInAppRoute = (url: string) => {
  return url.includes(baseUrl);
};
